export default function ChevronDropdownIcon({
  className,
  title,
}: {
  className?: string;
  title?: string;
}) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="currentColor"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M10 13.9717C9.75033 13.9717 9.52181 13.8701 9.31445 13.667L4.53467 8.7793C4.45426 8.69466 4.3929 8.60368 4.35059 8.50635C4.3125 8.40902 4.29346 8.30111 4.29346 8.18262C4.29346 8.02604 4.33154 7.88216 4.40771 7.75098C4.48389 7.61979 4.58545 7.51611 4.7124 7.43994C4.84359 7.36377 4.98747 7.32568 5.14404 7.32568C5.38102 7.32568 5.58838 7.41243 5.76611 7.58594L10.292 12.2324H9.71436L14.2275 7.58594C14.4053 7.41243 14.6126 7.32568 14.8496 7.32568C15.0062 7.32568 15.1479 7.36377 15.2749 7.43994C15.4061 7.51611 15.5098 7.61979 15.5859 7.75098C15.6621 7.88216 15.7002 8.02604 15.7002 8.18262C15.7002 8.41536 15.6177 8.61214 15.4526 8.77295L10.6855 13.667C10.584 13.7686 10.4761 13.8447 10.3618 13.8955C10.2518 13.9421 10.1312 13.9674 10 13.9717Z" />
      {title && <title>{title}</title>}
    </svg>
  );
}
